import React from "react";
import { SUDOKU_STRATEGY_ARRAY, SudokuStrategy } from "sudokuru";

// Clones Sudoku Strategy Array and removes Amend Notes and Simplify notes from list
export const returnSudokuStrategyArray = () => {
  return [...SUDOKU_STRATEGY_ARRAY.slice(2)];
};

export const PreferencesContext = React.createContext({
  updateCurrentPage: (props: any) => {},
  currentPage: "Home",
  updateLearnedLessons: (props: any) => {},
  learnedLessons: [""],
  toggleHighlightIdenticalValues: () => {},
  highlightIdenticalValuesSetting: true,
  toggleHighlightBox: () => {},
  highlightBoxSetting: true,
  toggleHighlightRow: () => {},
  highlightRowSetting: true,
  toggleHighlightColumn: () => {},
  highlightColumnSetting: true,
  toggleProgressIndicator: () => {},
  progressIndicatorSetting: true,
  toggleFeaturePreview: () => {},
  featurePreviewSetting: false,
  toggleDrillMode: () => {},
  drillModeSetting: true,
  toggleInitializeNotes: () => {},
  initializeNotesSetting: true,
  toggleSimplifyNotes: () => {},
  simplifyNotesSetting: true,
  updateStrategyHintOrder: (props: SudokuStrategy[]) => {},
  strategyHintOrderSetting: returnSudokuStrategyArray(),
});
